export default __webpack_public_path__ + "static/media/city-walk.2a44539d.webp";